
import { useEffect } from "react";
import { supabase } from "@/lib/supabase";
import { FilterState, ReportQueryResponse } from "./types";

export const usePrefetchAdjacent = (
  queryClient: any,
  filterState: FilterState,
  searchTerm: string,
  isLoading: boolean,
  data: any
) => {
  const { currentPage, itemsPerPage, selectedCategory, sortBy, sortOrder } = filterState;

  useEffect(() => {
    const prefetchAdjacentPages = async () => {
      if (currentPage > 1) {
        queryClient.prefetchQuery({
          queryKey: ['reports', searchTerm, selectedCategory, sortBy, sortOrder, currentPage - 1, itemsPerPage],
          queryFn: async () => {
            const start = (currentPage - 2) * itemsPerPage;
            const { data } = await (supabase.from as any)('reports')
              .select('*')
              .eq(selectedCategory ? 'category' : 'id', selectedCategory || 'id')
              .order(sortBy === 'date' ? 'created_at' : sortBy, { ascending: sortOrder === 'asc' })
              .range(start, start + itemsPerPage - 1);
            return { data, count: 0 } as ReportQueryResponse;
          },
          staleTime: 2 * 60 * 1000, // 2 minutes
        });
      }

      queryClient.prefetchQuery({
        queryKey: ['reports', searchTerm, selectedCategory, sortBy, sortOrder, currentPage + 1, itemsPerPage],
        queryFn: async () => {
          const start = currentPage * itemsPerPage;
          const { data } = await (supabase.from as any)('reports')
            .select('*')
            .eq(selectedCategory ? 'category' : 'id', selectedCategory || 'id')
            .order(sortBy === 'date' ? 'created_at' : sortBy, { ascending: sortOrder === 'asc' })
            .range(start, start + itemsPerPage - 1);
          return { data, count: 0 } as ReportQueryResponse;
        },
        staleTime: 2 * 60 * 1000, // 2 minutes
      });
    };

    if (!isLoading && data?.data?.length > 0) {
      prefetchAdjacentPages();
    }
  }, [currentPage, itemsPerPage, selectedCategory, sortBy, sortOrder, queryClient, data, isLoading, searchTerm]);
};
